
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.ExtendedLeaguesCoaches = View.LeaguesCoaches.extend({
		ui: {
			'remove_user': '.js-remove-user',
			'show_more':   '.js-more',
			'remove_team': '.js-remove-team',
			'make_paid':   '.js-make-paid',
			'make_admin':  '.js-make-admin'
		},
		events: {
			'click @ui.remove_user': 'removeUser',
			'click @ui.remove_team': 'removeTeam',
			'click @ui.show_more':   'loadMore',
			'change @ui.make_paid':  'makePaid',
			'change @ui.make_admin': 'makeAdmin'
		},
		canMakeAdmin:  true,
		canMakePaid:   false,
		canRemoveUser: true,
		initListners: function () {
			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:remove_coach:success', this.coachRemoved);
			this.listenTo(this.league, 'leagues:edit_users:success', this.successUser);
			this.listenTo(APP.vent,    'leagues_manage_controls:change_league', this.changeLeague);
		},
		successUser: function () {
			this.hidePreloader();
			return this;
		},
		getSelectedUserData: function (user_id) {
			return {
				user_id: user_id,
				status: $('[name="make_admin"][data-id="' + user_id + '"]').is(':checked') ? 'commissioner' : 'user',
				paid: $('[name="make_paid"][data-id="' + user_id + '"]').is(':checked') ? 1 : 0
			};
		},
		makePaid: function (el) {
			var current_user = $(el.currentTarget).data('id');
			this.editUser(this.getSelectedUserData(current_user));
		},
		makeAdmin: function (el) {
			var current_user = $(el.currentTarget).data('id');
			if ( !this.preventChangeCommissionerRights(current_user) ) {
				this.editUser(this.getSelectedUserData(current_user));
			}
		},
		preventChangeCommissionerRights: function (user_id) {
			var user = APP.module('instance').user;
			if ( this.league.get('commissioner') == user_id && user.get('id') != this.league.get('commissioner') ) {
				this.showErrors([{"text": "You can't deny commissioner rights"}]);
				return true;
			}
			return false;
		},
		editUser: function(params) {
			var data = {
				"league_id": this.league.get('id'),
				"users": [params]
			};
			this.showPreloader();
			this.league.edit_users(data);
		},
		setOriginalCommissioner: function (user_id) {
			var commissioner = this.league.get('commissioner') == user_id ? user_id : this.league.get('commissioner');
			this.coaches.each(function(coach) {
				//specify league creator
				coach.set('original_commissioner', coach.get('id') == commissioner ? commissioner : -1);
			});
		},
		setModelData: function() {
			var user = APP.module('instance').user;
			this.setOriginalCommissioner(user.get('id'));
			this.model.set({
				league:        this.league.toJSON(),
				coaches:       this.coaches.toJSON(),
				avatars_url:   CONFIG.AVATARS_URL,
				canMakeAdmin:  this.canMakeAdmin,
				canMakePaid:   this.canMakePaid && this.league.get('privacy') == 'private',
				canRemoveUser: this.canRemoveUser
			});
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));